import React from 'react';
import { motion } from 'framer-motion';
import { WebsiteHeader } from '../components/Dashboard/WebsiteHeader';
import { ReferralStats } from '../components/Referral/ReferralStats';
import { ReferralLinkCard } from '../components/Referral/ReferralLinkCard';
import { ReferralHistory } from '../components/Referral/ReferralHistory';
import { useReferrals } from '../hooks/useReferrals';
export function ReferralsPage() {
  const {
    referralCode,
    referrals,
    stats,
    loading,
    error
  } = useReferrals();
  return <div className="min-h-screen w-full bg-[#050505] text-white" data-id="element-9814" data-mp="36rt6as9v2utq">
      <WebsiteHeader data-id="element-9815" data-mp="36p6welzi038c" />

      <main className="relative z-10 mx-auto w-full max-w-6xl px-4 pb-24 pt-8 md:px-6 md:pt-12" data-id="element-9816" data-mp="2ss9y5zh1vjhf">
        <motion.header initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mb-10 max-w-2xl" data-id="element-9817" data-mp="2xqbsjgjxf587">
          <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.2em] text-[#FF0000]" data-id="element-9818" data-mp="2dp8dfo7nfnxi">
            Referral program
          </p>
          <h1 className="text-3xl font-black uppercase leading-none tracking-tight text-white md:text-4xl" data-id="element-9819" data-mp="29oy5w747kpgj">
            Invite Friends, Earn Free Scans 🚀
          </h1>
          <p className="mt-4 text-base leading-relaxed text-gray-400" data-id="element-9820" data-mp="2ilysc87pwdhc">
            Share your unique link. When your friend completes their first scan,
            you both unlock 5 free scan credits.
          </p>
        </motion.header>

        <div className="mb-8" data-id="element-9821" data-mp="36d4jvkn0su7h">
          <ReferralStats stats={stats} loading={loading} data-id="element-9822" data-mp="36ddykc2m7exv" />
        </div>

        <div className="mb-10" data-id="element-9823" data-mp="31e1bbq7u05ur">
          <ReferralLinkCard referralCode={referralCode} loading={loading} data-id="element-9824" data-mp="31f2pi3k598gp" />
        </div>

        <ReferralHistory referrals={referrals} referralCode={referralCode} loading={loading} error={error} data-id="element-9825" data-mp="3gaiommzkzujy" />
      </main>
    </div>;
}